export default {
  loginHeader: {
    appName: "Iris",

    languageTooltip: "Select Language",
    languages: {
      en: "English",
      bg: "Bulgarian",
      mk: "Macedonian",
    },
  },

  loginForm: {
    title: "Iris",
    subtitle: "Laboratory Information System",
    description:
      "Streamline your laboratory workflow with comprehensive sample tracking, real-time validation, and secure multi-user access. Built for efficiency, designed for laboratory professionals.",
    loginButtonText: "Sign in to Iris",
  },
};
